export default {
  zh: {
    timeR: '倒计时: ',
    ruleText: '规则',
    DailyBenefits: '每日福利',
    rule: '1. 用户必须是女性，并且没有改变性别，如果改变性别，将自动失去资格。<br/>2. 需要在商店中进行5星评论并在注册申请中发送截图。<br/>3. 用户必须在每星期一到星期四使用麦克风8小时，或者星期五到星期日使用麦克风6小时。静音操作不会被计算在内。<br/>4. 经批准的女孩将在周一和周五分别收到 6000 个硬币。<br/>5. 每个用户只能在一台设备上注册，如果在一台设备上检测到多个帐户，将直接取消资格。<br/>',
    content: '',
    mission: '任务',
    ranking: '排行',
    individual: '个人',
    room: '房间',
    rewards: '奖励',
    amount: '完成额度',
    collect: '收集',
    copyright: '本活动版权归App所有',
    collected: '收到',
    specialgift: 'special background gift',
    fail: "你错过了一步。请填写该表格。",
    comp: "Submission completed.one of our team will contact you shortly.",
    chatrule: "App拥有本次活动的最终权利。",
    lvFail: "为了参加这个活动。您必须在魅力或财富方面至少达到 10 级。",

    noSex: "性别不是女性或者最近7天内更改过性别",
    hadSuc: "您当前已经申请过了",

    checkPic: "检测到您没有上传截图",
    introduce: `为了让我们更好地了解您，请您自我介绍。最多300字`,
    apply: "申请",
    trOne:"Level",
    trTwo:"Number of microphone  hours",
    trThree:"Number of users who send gifts",
    trFour:"Value of gifts received",
    trFive:"Reward",
  },
  en: {
    timeR: 'Count down: ',
    ruleText: 'Rule',
    DailyBenefits: 'Daily Benefits',
    rule: '1. Users must be female and have not changed their gender. If they change their gender, they will be automatically disqualified.<br/>2. Need to make a 5-star review in the store and send a screenshot in the registration application.<br/>3. Users must use the microphone for 8 hours from Monday to Thursday, or 6 hours from Friday to Sunday. Silent operations are not counted.<br/>4. Approved girls will receive 6000 coins each on Monday and Friday.<br/>5. Each user can only register on one device, if multiple accounts are detected on one device, they will be directly disqualified.',
    content: '',
    mission: 'mission',
    ranking: 'ranking',
    individual: 'individual',
    room: 'room',
    rewards: 'rewards',
    amount: 'Amount accomplished',
    collect: 'collect',
    copyright: 'The copyright of this activity belongs to App',
    collected: 'received',
    specialgift: 'special background gift',
    fail: "You have missed a step. Please fill the form.",
    comp: "Submission completed.one of our team will contact you shortly.",
    chatrule: "App has the final right of this activity.",
    lvFail: "In order to participate on this event.You must reach a minimum of level 10 on Charm or Wealth. ",

    noSex: "Gender is not female or has been changed in the past 7 days",
    hadSuc: "You have already applied",

    checkPic: "Detected that you did not upload a screenshot",

    introduce: `For us to know better about you. Please introduce yourself.300 words Max`,
    apply: "Apply",
    trOne:"Level",
    trTwo:"Number of microphone  hours",
    trThree:"Number of users who send gifts",
    trFour:"Value of gifts received",
    trFive:"Reward",
  },
  ar: {
    timeR: 'العد التنازلي ',
    ruleText: 'قواعد',
    DailyBenefits: 'المكافأة اليومية',
    rule: '1.  يجب أن يكون المستخدم أنثى ولم يغير جنسه. إذا غيّرت جنسها، فسيتم استبعادها تلقائياً.<br/>2. تحتاج إلى إجراء مراجعة 5 نجوم في المتجر وإرسال لقطة شاشة في تطبيق لتسجيل.<br/>3.  يجب على المستخدمين استخدام الميكروفون لمدة 8 ساعات من الاثنين إلى الخميس، و 6 ساعات من الجمعة إلى الأحد. لا لم يتم احتساب كتم المايك .<br/>4.  ستحصل الفتيات المعتمدات على 6000 عملة نقدية في يوم الاثنين والجمعة<br/>5.  يمكن لكل مستخدم التسجيل على جهاز واحد فقط، إذا تم اكتشاف حسابات متعددة على جهاز واحد، سيتم استبعادهم مباشرة.',
    content: '',
    mission: 'بعثة',
    ranking: 'تصنيف',
    individual: 'فرد',
    room: 'مجال',
    rewards: 'المكافآت',
    amount: 'المبلغ المنجز',
    collect: 'يجمع',
    copyright: 'حقوق الطبع والنشر لهذا النشاط تعود إلى App',
    collected: 'استلم',
    specialgift: 'هدية خلفية خاصة',
    fail: "لقد فاتتك خطوة. الرجاء تعبئة النموذج.",
    comp: "اكتمل التقديم.سيتصل بك أحد أعضاء فريقنا قريبًا.",
    chatrule: "App لديه الحق النهائي في هذا النشاط.",
    lvFail: "من أجل المشاركة في هذا الحدث.يجب أن تصل إلى المستوى 10 على الأقل في السحر أو الثروة.",

    noSex: "الجنس ليس أنثى أو تم تغييره في الأيام السبعة الماضية",
    hadSuc: "كنت قد تقدمت بالفعل",

    checkPic: "تم الاكتشاف وانت لم تقم بتحميل لقطات الشاشة",
    introduce: `بالنسبة لنا لمعرفة أفضل عنك. يرجى تقديم نفسك 300 كلمة كحد أقصى`,
    apply: `تطبق`,
    trOne:"المستوى",
    trTwo:"عدد ساعات المايك",
    trThree:"عدد الداعمين",
    trFour:"اجمالي قيمة الهدايا",
    trFive:"الجائزة",
  },
  tr: {
    timeR: 'Kalan süre: ',
    ruleText: 'Rule',
    DailyBenefits: 'Daily Benefits',
    rule: "1. Kullanıcıların kadın olması ve cinsiyetlerini değiştirmemiş olmaları gerekmektedir, eğer cinsiyetlerini değiştirirlerse otomatik olarak diskalifiye edilecektir. <br/>2. Mağazada 5 yıldızlı bir inceleme yapmanız ve kayıt başvurusunda bir ekran görüntüsü göndermeniz gerekir. <br/>3. Kullanıcılar mikrofonu Pazartesi'den Perşembe'ye 8 saat veya Cuma'dan Pazar'a 6 saat kullanmalıdır. Sessiz işlemler sayılmaz. <br/>4. Onaylanan kızların her biri Pazartesi ve Cuma günleri 6000 jeton alacak. <br/>5. Her kullanıcı yalnızca bir cihazda kayıt olabilir, bir cihazda birden fazla hesap tespit edilirse doğrudan diskalifiye edilecektir. <br/>",
    content: '',
    mission: 'misyon',
    ranking: 'sıralama',
    individual: 'bireysel',
    room: 'oda',
    rewards: 'ödüller',
    amount: 'Tamamlanan miktar',
    collect: 'toplamak',
    copyright: "Bu etkinliğin telif hakkı App'ye aittir.",
    collected: 'alındı',
    specialgift: 'özel arka plan hediyesi',
    fail: "Bir adımı atladınız. Lütfen formu doldurun.",
    comp: "Gönderim tamamlandı.ekibimizden biri kısa süre içinde sizinle iletişime geçecektir.",
    chatrule: "App bu aktivitenin son hakkına sahiptir.",
    lvFail: "Bu etkinliğe katılmak için.Charm veya Wealth'te en az 10. seviyeye ulaşmalısınız.",

    noSex: "Cinsiyet kadın değil veya son yedi gün içinde cinsiyet değiştirildi",
    hadSuc: "zaten başvurdun",


    checkPic: "Ekran görüntüsü yüklemediğiniz tespit edildi.",
    introduce: `Sizi daha iyi tanımamız için. Lütfen kendinizi tanıtın.300 kelime Max`,
    apply: `uygula`,
    trOne:"Seviye",
    trTwo:"Mikrofon Saat Süresi",
    trThree:"Hediye Gönderen Kullanıcı Sayısı",
    trFour:"Alınan Hediyelerin Değeri",
    trFive:"Ödül",
  },
  jp: {
    timeR: 'カウントダウン: ',
    ruleText: 'Rule',
    DailyBenefits: 'Daily Benefits',
    rule: '1. 性別を変更していない女性であること 性別を変更した場合、自動的に失格となります。 <br/>2. ストアで 5 つ星のレビューを作成し、登録アプリケーションでスクリーンショットを送信する必要があります。 <br/>3. ユーザーは、月曜日から木曜日まで 8 時間、または金曜日から日曜日まで 6 時間、マイクを使用する必要があります。 サイレント操作はカウントされません。 <br/>4. 承認された女の子は月曜日と金曜日にそれぞれ 6000 コインを受け取ります。 <br/>5. 各ユーザーは 1 つのデバイスにのみ登録できます。1 つのデバイスで複数のアカウントが検出された場合、それらは直接失格となります。 <br/>',
    content: '',
    mission: 'ミッション',
    ranking: 'ランキング',
    individual: '個人',
    room: '部屋',
    rewards: '報酬',
    amount: '達成量',
    collect: '収集',
    copyright: 'この活動の著作権はAppに帰属します',
    collected: '受信',
    specialgift: '特別な背景ギフト',
    fail: "あなたは一歩を逃しました。フォームに記入してください。",
    comp: "提出が完了しました。私たちのチームの1人がまもなくご連絡します。",
    chatrule: "App は、このアクティビティの最終的な権利を有します。",
    lvFail: "このイベントに参加するため。チャームまたはウェルスで最低レベル 10 に到達する必要があります。",

    noSex: "性別が女性ではないか、過去 7 日間に性別が変更されました",
    hadSuc: "あなたはすでに適用されています",


    checkPic: "スクリーンショットをアップロードしていないことが検出されました",
    introduce: `あなたのことをもっとよく知るため。 自己紹介をお願いします。300字以内`,
    apply: `申し込む`,
    trOne:"Level",
    trTwo:"Number of microphone  hours",
    trThree:"Number of users who send gifts",
    trFour:"Value of gifts received",
    trFive:"Reward",
  },
  pt:{
    "timeR": "Contagem regressiva: ",
    "ruleText": "Regra",
    "DailyBenefits": "Benefícios Diários",
    "rule": "1. Os usuários devem ser do sexo feminino e não ter alterado seu gênero. Se mudarem de gênero, serão automaticamente desqualificados.<br/>2. É necessário fazer uma avaliação de 5 estrelas na loja e enviar uma captura de tela na solicitação de registro.<br/>3. Os usuários devem usar o microfone por 8 horas de segunda a quinta-feira ou 6 horas de sexta a domingo. Operações silenciosas não são contabilizadas.<br/>4. As garotas aprovadas receberão 6000 moedas cada uma na segunda-feira e na sexta-feira.<br/>5. Cada usuário pode se registrar em apenas um dispositivo; se várias contas forem detectadas em um único dispositivo, serão diretamente desqualificadas.",
    "content": "",
    "mission": "missão",
    "ranking": "classificação",
    "individual": "individual",
    "room": "sala",
    "rewards": "recompensas",
    "amount": "Quantidade concluída",
    "collect": "coletar",
    "copyright": "Os direitos autorais desta atividade pertencem ao App",
    "collected": "recebido",
    "specialgift": "presente de fundo especial",
    "fail": "Você pulou uma etapa. Por favor, preencha o formulário.",
    "comp": "Envio concluído. Um membro da nossa equipe entrará em contato com você em breve.",
    "chatrule": "O App tem o direito final sobre esta atividade.",
    "lvFail": "Para participar deste evento, você deve atingir pelo menos o nível 10 em Charme ou Riqueza.",

    "noSex": "O gênero não é feminino ou foi alterado nos últimos 7 dias",
    "hadSuc": "Você já se inscreveu",

    "checkPic": "Detectamos que você não enviou uma captura de tela",

    "introduce": "Para que possamos conhecê-lo melhor, apresente-se. Máximo de 300 palavras.",
    "apply": "Inscrever-se",
    "trOne": "Nível",
    "trTwo": "Número de horas de microfone",
    "trThree": "Número de usuários que enviam presentes",
    "trFour": "Valor dos presentes recebidos",
    "trFive": "Recompensa"
},
    id:{
    "timeR": "Hitung mundur: ",
    "ruleText": "Aturan",
    "DailyBenefits": "Manfaat Harian",
    "rule": "1. Pengguna harus perempuan dan belum mengubah jenis kelamin mereka. Jika mereka mengubah jenis kelamin, mereka akan didiskualifikasi secara otomatis.<br/>2. Harus memberikan ulasan bintang 5 di toko dan mengirimkan tangkapan layar dalam aplikasi pendaftaran.<br/>3. Pengguna harus menggunakan mikrofon selama 8 jam dari Senin hingga Kamis, atau 6 jam dari Jumat hingga Minggu. Operasi diam tidak dihitung.<br/>4. Pengguna perempuan yang disetujui akan menerima 6000 koin masing-masing pada hari Senin dan Jumat.<br/>5. Setiap pengguna hanya dapat mendaftar di satu perangkat; jika terdeteksi beberapa akun di satu perangkat, mereka akan langsung didiskualifikasi.",
    "content": "",
    "mission": "misi",
    "ranking": "peringkat",
    "individual": "individu",
    "room": "ruangan",
    "rewards": "hadiah",
    "amount": "Jumlah yang dicapai",
    "collect": "kumpulkan",
    "copyright": "Hak cipta aktivitas ini dimiliki oleh Aplikasi",
    "collected": "diterima",
    "specialgift": "hadiah latar belakang khusus",
    "fail": "Anda melewatkan satu langkah. Harap isi formulir.",
    "comp": "Pengiriman selesai. Salah satu tim kami akan segera menghubungi Anda.",
    "chatrule": "Aplikasi memiliki hak akhir atas aktivitas ini.",
    "lvFail": "Untuk berpartisipasi dalam acara ini, Anda harus mencapai level minimum 10 dalam Pesona atau Kekayaan.",

    "noSex": "Jenis kelamin bukan perempuan atau telah diubah dalam 7 hari terakhir",
    "hadSuc": "Anda sudah mendaftar",

    "checkPic": "Terdeteksi bahwa Anda tidak mengunggah tangkapan layar",

    "introduce": "Agar kami lebih mengenal Anda, silakan perkenalkan diri Anda. Maksimal 300 kata.",
    "apply": "Daftar",
    "trOne": "Level",
    "trTwo": "Jumlah jam mikrofon",
    "trThree": "Jumlah pengguna yang mengirim hadiah",
    "trFour": "Nilai hadiah yang diterima",
    "trFive": "Hadiah"
},
    uz:{
    "timeR": "Orqaga sanoq: ",
    "ruleText": "Qoidalar",
    "DailyBenefits": "Kunlik imtiyozlar",
    "rule": "1. Foydalanuvchilar ayol bo‘lishi va jinsini o‘zgartirmagan bo‘lishi kerak. Agar ular jinsini o‘zgartirsa, avtomatik ravishda diskvalifikatsiya qilinadi.<br/>2. Do‘konda 5 yulduzli sharh qoldirish va ro‘yxatdan o‘tish arizasida skrinshot yuborish kerak.<br/>3. Foydalanuvchilar dushanbadan payshanbagacha 8 soat, jumadan yakshanbagacha esa 6 soat mikrofon ishlatishlari shart. Jim bo‘lish holatlari hisobga olinmaydi.<br/>4. Tasdiqlangan qizlar dushanba va juma kunlari har biri 6000 tanga oladi.<br/>5. Har bir foydalanuvchi faqat bitta qurilmadan ro‘yxatdan o‘tishi mumkin, agar bir qurilmada bir nechta hisob qaydnomasi aniqlansa, ular darhol diskvalifikatsiya qilinadi.",
    "content": "",
    "mission": "vazifa",
    "ranking": "reyting",
    "individual": "shaxsiy",
    "room": "xona",
    "rewards": "mukofotlar",
    "amount": "Bajarilgan miqdor",
    "collect": "to‘plash",
    "copyright": "Ushbu faoliyatning mualliflik huquqi Appga tegishli",
    "collected": "qabul qilindi",
    "specialgift": "maxsus fon sovg‘asi",
    "fail": "Siz bir bosqichni o'tkazib yubordingiz. Iltimos, shaklni to‘ldiring.",
    "comp": "Yuborish yakunlandi. Jamoamizdan biri tez orada siz bilan bog‘lanadi.",
    "chatrule": "App ushbu faoliyat bo‘yicha yakuniy huquqqa ega.",
    "lvFail": "Ushbu tadbirda ishtirok etish uchun siz Joziba yoki Boylik bo‘yicha kamida 10-darajaga yetishingiz kerak.",

    "noSex": "Jins ayol emas yoki so‘nggi 7 kun ichida o‘zgartirilgan",
    "hadSuc": "Siz allaqachon ariza topshirgansiz",

    "checkPic": "Siz skrinshot yuklamaganingiz aniqlandi",

    "introduce": "Siz haqingizda yaxshiroq bilishimiz uchun iltimos, o‘zingizni tanishtiring. Maksimal 300 so‘z.",
    "apply": "Ariza topshirish",
    "trOne": "Daraja",
    "trTwo": "Mikrofon soatlari soni",
    "trThree": "Sovg‘a yuborgan foydalanuvchilar soni",
    "trFour": "Olingan sovg‘alar qiymati",
    "trFive": "Mukofot"
},
    ru:{
    "timeR": "Обратный отсчёт: ",
    "ruleText": "Правила",
    "DailyBenefits": "Ежедневные бонусы",
    "rule": "1. Пользователи должны быть женского пола и не менять свой пол. В случае изменения пола они автоматически дисквалифицируются.<br/>2. Необходимо оставить 5-звёздочный отзыв в магазине и отправить скриншот в регистрационной заявке.<br/>3. Пользователи должны использовать микрофон в течение 8 часов с понедельника по четверг или 6 часов с пятницы по воскресенье. Беззвучные сеансы не засчитываются.<br/>4. Одобренные участницы будут получать по 6000 монет в понедельник и пятницу.<br/>5. Каждый пользователь может зарегистрироваться только с одного устройства. Если на одном устройстве обнаружены несколько аккаунтов, они будут дисквалифицированы.",
    "content": "",
    "mission": "задание",
    "ranking": "рейтинг",
    "individual": "индивидуально",
    "room": "комната",
    "rewards": "награды",
    "amount": "Выполненный объём",
    "collect": "собрать",
    "copyright": "Авторские права на эту активность принадлежат App",
    "collected": "получено",
    "specialgift": "специальный фоновый подарок",
    "fail": "Вы пропустили шаг. Пожалуйста, заполните форму.",
    "comp": "Отправка завершена. Один из членов нашей команды скоро свяжется с вами.",
    "chatrule": "App обладает окончательным правом на данное мероприятие.",
    "lvFail": "Чтобы участвовать в этом событии, вам необходимо достичь как минимум 10 уровня Очарования или Богатства.",

    "noSex": "Пол не женский или был изменён за последние 7 дней",
    "hadSuc": "Вы уже подали заявку",

    "checkPic": "Обнаружено, что вы не загрузили скриншот",

    "introduce": "Чтобы мы могли лучше узнать вас, пожалуйста, представьтесь. Максимум 300 слов.",
    "apply": "Подать заявку",
    "trOne": "Уровень",
    "trTwo": "Количество часов с микрофоном",
    "trThree": "Количество пользователей, отправивших подарки",
    "trFour": "Стоимость полученных подарков",
    "trFive": "Награда"
},
    fa:{
    "timeR": "شمارش معکوس: ",
    "ruleText": "قوانین",
    "DailyBenefits": "مزایای روزانه",
    "rule": "1. کاربران باید زن باشند و جنسیت خود را تغییر نداده باشند. در صورت تغییر جنسیت، به طور خودکار رد صلاحیت می‌شوند.<br/>2. باید یک بررسی ۵ ستاره در فروشگاه انجام دهند و اسکرین‌شات آن را در درخواست ثبت‌نام ارسال کنند.<br/>3. کاربران باید از دوشنبه تا پنجشنبه ۸ ساعت یا از جمعه تا یکشنبه ۶ ساعت از میکروفون استفاده کنند. فعالیت‌های بی‌صدا محاسبه نمی‌شوند.<br/>4. دختران تایید شده روزهای دوشنبه و جمعه هر کدام ۶۰۰۰ سکه دریافت خواهند کرد.<br/>5. هر کاربر فقط می‌تواند با یک دستگاه ثبت‌نام کند. در صورت شناسایی چندین حساب در یک دستگاه، آنها مستقیماً رد صلاحیت خواهند شد.",
    "content": "",
    "mission": "ماموریت",
    "ranking": "رتبه‌بندی",
    "individual": "فردی",
    "room": "اتاق",
    "rewards": "جوایز",
    "amount": "مقدار انجام شده",
    "collect": "جمع‌آوری",
    "copyright": "حق چاپ این فعالیت متعلق به App است",
    "collected": "دریافت شد",
    "specialgift": "هدیه پس‌زمینه ویژه",
    "fail": "یک مرحله را جا انداخته‌اید. لطفاً فرم را پر کنید.",
    "comp": "ارسال تکمیل شد. یکی از اعضای تیم ما به زودی با شما تماس خواهد گرفت.",
    "chatrule": "App حق نهایی این فعالیت را دارد.",
    "lvFail": "برای شرکت در این رویداد، باید حداقل سطح ۱۰ در جذابیت یا ثروت را داشته باشید.",

    "noSex": "جنسیت زن نیست یا در ۷ روز گذشته تغییر کرده است",
    "hadSuc": "شما قبلاً درخواست داده‌اید",

    "checkPic": "مشخص شد که شما اسکرین‌شات بارگذاری نکرده‌اید",

    "introduce": "برای اینکه ما بهتر شما را بشناسیم، لطفاً خود را معرفی کنید. حداکثر ۳۰۰ کلمه.",
    "apply": "درخواست دادن",
    "trOne": "سطح",
    "trTwo": "تعداد ساعات استفاده از میکروفون",
    "trThree": "تعداد کاربران ارسال‌کننده هدیه",
    "trFour": "ارزش هدایا دریافت‌شده",
    "trFive": "پاداش"
}





}



// WEBPACK FOOTER //
// src/pages/activity/ladiesregister/lang.js